import PrintOnEnum from '../printOn/PrintOn.enum';
import NetStampSeries from './NetStampSeries.enum';
import PrintLayout from './PrintLayout.enum';

export default class PrintTypeHelper {
	static getSwsimNetStampLayout(sheetType) {
		const netStampsLayoutMap = {
			[NetStampSeries.Alternate]: PrintLayout.Alternate,
			[NetStampSeries.PhotoLandscape]: PrintLayout.PhotoLandscape,
			[NetStampSeries.PhotoLandscapeHs]: PrintLayout.PhotoLandscapeHS,
			[NetStampSeries.PhotoPortrait]: PrintLayout.PhotoPortrait,
			[NetStampSeries.PromoPaper20]: PrintLayout.PromoPaper20Netstamps,
			[NetStampSeries.Promotional]: PrintLayout.Promotional,
			[NetStampSeries.Standard]: PrintLayout.Standard,
			[NetStampSeries.Themed]: PrintLayout.Themed,
			[NetStampSeries.Traditional]: PrintLayout.Traditional,
			[NetStampSeries.ReturnAddress]: PrintLayout.ReturnAddress,
			[NetStampSeries.RollTypeSorD]: PrintLayout.RollTypeSorD,
		};

		return netStampsLayoutMap[sheetType];
	}

	static getSeraEnvelopeType(printOn) {
		const envelopeTypeMap = {
			[PrintOnEnum.EnvelopeA2]: 'envelope_invitation',
			[PrintOnEnum.EnvelopeA9]: 'envelope_greeting',
			[PrintOnEnum.Envelope6]: 'envelope_personal',
			[PrintOnEnum.Envelope7]: 'envelope_monarch',
			[PrintOnEnum.Envelope9]: 'envelope9',
			[PrintOnEnum.Envelope10]: 'envelope10',
			[PrintOnEnum.Envelope11]: 'envelope11',
			[PrintOnEnum.Envelope12]: 'envelope12',
		};

		return envelopeTypeMap[printOn];
	}

	static isLabelLetterSize(requestPrintLayout) {
		const letterSizeLayouts = [
			PrintLayout.NormalLeft,
			PrintLayout.NormalRight,
			PrintLayout.NormalReceipt,
			PrintLayout.Sdc3610,
			PrintLayout.Sdc3710,
			PrintLayout.Sdc3910,
			PrintLayout.Sdc3930,
			PrintLayout.Sdc3810,
			PrintLayout.Sdc3830,
		];

		return letterSizeLayouts.includes(requestPrintLayout);
	}

	static isEnvelopePrint(printOn) {
		const envelopePrintOn = [
			PrintOnEnum.EnvelopeA2,
			PrintOnEnum.EnvelopeA9,
			PrintOnEnum.Envelope6,
			PrintOnEnum.Envelope7,
			PrintOnEnum.Envelope9,
			PrintOnEnum.Envelope10,
			PrintOnEnum.Envelope11,
			PrintOnEnum.Envelope12,
		];

		return envelopePrintOn.includes(printOn);
	}

	static getCertifiedMailPrintOn(requestedPrintLayout) {
		const certifiedMailMap = {
			[PrintLayout.Sdc3610]: PrintOnEnum.MailingLabelCM3610,
			[PrintLayout.Sdc3710]: PrintOnEnum.MailingLabelCM3710,
			[PrintLayout.Sdc3910]: PrintOnEnum.MailingLabelCM3910,
			[PrintLayout.Sdc3930]: PrintOnEnum.MailingLabelCM3930,
			[PrintLayout.Sdc3810]: PrintOnEnum.EnvelopeCM3810,
			[PrintLayout.Sdc3830]: PrintOnEnum.EnvelopeCM3830,
		};

		return certifiedMailMap[requestedPrintLayout];
	}
}
